export const EAssignOrganisationFields = {
	organisation: 'organisation',
	roles: 'roles',
	jobTitle: 'jobTitle',
} as const;
